var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cv-content',{staticStyle:{"width":"100vw"},attrs:{"id":"main-content"}},[_c('cv-data-table',{attrs:{"columns":_vm.colonne,"data":_vm.righe,"title":"Province","helper-text":"Elenco delle province italiane"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }